import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import EditIcon from '@mui/icons-material/Edit'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { EditProps } from '../shared/EditProps'
import PriceIcon from '@mui/icons-material/Euro'
import { useAuth } from '../../context/useAuth'

export default function EditPrice({ disabled, schema, value, setData }: EditProps) {
  const { name } = useParams()
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Edit Price`}
      icon={<PriceIcon />}
      iconButton={<EditIcon />}
      content={
        <Form
          onSubmit={async (e) => {
            try {
              const res = await axios.put(
                `${process.env.REACT_APP_API}/${name}/price/${value.name}`,
                JSON.stringify(e.formData),
                {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrf,
                  },
                  withCredentials: true,
                }
              )
              setData(res.data)
              setOpen(false)
            } catch (err) {
              console.log('err:', err)
            }
          }}
          validator={validator}
          schema={schema as JSONSchema7}
          formData={value}
        />
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
